// PRD 05 §2.2 #8 — 3-color branch chip on choice rows.
//   NEXT → blue   (next question)
//   END  → red    (end)
//   JUMP → purple (→ question N-M)

import { useTranslation } from 'react-i18next';

import type { BranchRef } from '../types/questionnaire-design.types';

interface BranchChipProps {
  branch: BranchRef | undefined;
  // Pre-resolved display number for the JUMP target (e.g. "1-2"). Falls back
  // to "?" when the target QID isn't found in the current item bucket — this
  // surfaces stale cross-item jumps to the author.
  jumpDisplayNum?: string | null;
}

const COLORS = {
  NEXT: { bg: '#E6EEFF', color: '#0B2E73' },
  END: { bg: '#FEE2E8', color: 'var(--destructive)' },
  JUMP: { bg: '#F0E6FF', color: '#6B21A8' },
} as const;

export function BranchChip({ branch, jumpDisplayNum }: BranchChipProps) {
  const { t } = useTranslation('questionnaire-design');
  const kind = branch?.kind ?? 'NEXT';
  const color = COLORS[kind];
  const label =
    kind === 'JUMP'
      ? t('answerEditor.branchJumpOption', {
          num: jumpDisplayNum ?? '?',
        })
      : kind === 'END'
        ? t('answerEditor.branchKindEnd')
        : t('answerEditor.branchKindNext');
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 4,
        fontSize: 'var(--font-size-xs)',
        fontWeight: 'var(--font-weight-medium)',
        whiteSpace: 'nowrap',
        background: color.bg,
        color: color.color,
      }}
    >
      {label}
    </span>
  );
}
